import { render, staticRenderFns } from "./SuppliersView.vue?vue&type=template&id=56b71cda&"
import script from "./SuppliersView.vue?vue&type=script&lang=js&"
export * from "./SuppliersView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports